import { apiRequestToastAsync } from "../../functions/FetchWithToast";
import {
    GET_ALL_TAG_GROUPS,
    GET_TAG_GROUP_BY_ID,
    UPDATE_TAG_GROUP,
    CREATE_TAG_GROUP,
    DELETE_TAG_GROUP
} from "../Api";

export const getAllTagGroupsAction = () => apiRequestToastAsync({
    request_details: GET_ALL_TAG_GROUPS,
    messages: {
        loading: 'Loading tag groups',
        done: 'Loaded all tag groups',
        error: 'Error loading tag groups'
    }
});

export const getTagGroupByIdAction = (id) => apiRequestToastAsync({
    request_details: GET_TAG_GROUP_BY_ID(id),
    messages: {
        loading: `Loading tag group ${id}`,
        done: `Loaded tag group ${id}`,
        error: `Error loading tag group ${id}`
    }
});

export const updateTagGroupAction = (data) => apiRequestToastAsync({
    request_details: UPDATE_TAG_GROUP(data),
    messages: {
        loading: `Updating ${data.name}`,
        done: `Updated ${data.name}`,
        error: `Error updating ${data.name}`
    }
});

export const createTagGroupAction = (data) => apiRequestToastAsync({
    request_details: CREATE_TAG_GROUP(data),
    messages: {
        loading: `Creating ${data.name}`,
        done: `Created ${data.name}`,
        error: `Error creating ${data.name}`
    }
});

export const deleteTagGroupById = (data) => apiRequestToastAsync({
    request_details: DELETE_TAG_GROUP(data.id),
    messages: {
        loading: `Deleting ${data.name}`,
        done: `Deleted ${data.name}`,
        error: `Error deleting ${data.name}`
    }
});